// Copy a validación's INE/license documents into a client's (customer/company)
// document slots — used by "Crear Cliente" on the validation page.
import supabase from "../supabase-client";

const VALIDACION_BUCKET = "validacion-docs";
const CLIENT_BUCKET = "client-docs";

// validacion_files.file_type → client_documents.file_type. CSF / comprobante de
// domicilio aren't captured in validaciones, so they're left for manual upload.
const VALIDACION_TO_CLIENT = {
  ine_front: "ine_front",
  ine_back: "ine_back",
  license_front: "license_front",
  license_back: "license_back",
};

export async function copyValidacionDocsToClient({
  validacionId,
  entityType,
  entityId,
  createdBy,
}) {
  const { data: files } = await supabase
    .from("validacion_files")
    .select("file_type, file_url, file_name")
    .eq("validacion_id", validacionId);

  let copied = 0;
  for (const f of files || []) {
    const target = VALIDACION_TO_CLIENT[f.file_type];
    if (!target) continue;
    const { data: blob, error: dlErr } = await supabase.storage
      .from(VALIDACION_BUCKET)
      .download(f.file_url);
    if (dlErr || !blob) continue;
    const safe = (f.file_name || `${target}.jpg`)
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-zA-Z0-9._-]/g, "_");
    const path = `${entityType}/${entityId}/${target}_${Date.now()}_${safe}`;
    const { error: upErr } = await supabase.storage
      .from(CLIENT_BUCKET)
      .upload(path, blob, { upsert: true, contentType: blob.type || undefined });
    if (upErr) continue;
    const { error: dbErr } = await supabase.from("client_documents").upsert(
      {
        entity_type: entityType,
        entity_id: entityId,
        file_type: target,
        file_url: path,
        file_name: f.file_name || safe,
        created_by: createdBy || null,
      },
      { onConflict: "entity_type,entity_id,file_type" }
    );
    if (!dbErr) copied++;
  }
  return copied;
}
